import { render, staticRenderFns } from "./AdminDocumentCategories.vue?vue&type=template&id=2773e9fe&"
import script from "./AdminDocumentCategories.vue?vue&type=script&lang=js&"
export * from "./AdminDocumentCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports